module.exports = {
	extends: [
		'/',
		'templates',
		'bulk',
		'layoutTrees'
	],

	config: {
		style: '',
	},
	
	methods: {
		onAttachDone: function(refreshResourcesOnly = false){
			// OVERWRITE SUB ACTIONS
		},
	},
};
